'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

require('./password.scss');

var _input = require('../input');

var _input2 = _interopRequireDefault(_input);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _iconButton = require('../icon-button');

var _iconButton2 = _interopRequireDefault(_iconButton);

var _title = require('../title');

var _title2 = _interopRequireDefault(_title);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PASSWORD_SCORE_GOOD = 33;
var PASSWORD_SCORE_STRONG = 66;
var ICON = {
  success: 'success',
  warning: 'warning',
  error: 'error'
};

var PasswordGenerator = function (_React$Component) {
  _inherits(PasswordGenerator, _React$Component);

  _createClass(PasswordGenerator, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.value !== state.password.value) {
        return {
          password: _extends({}, state.password, {
            value: props.value,
            isAutoGenerated: false
          })
        };
      }

      return null;
    }
  }]);

  function PasswordGenerator(props) {
    _classCallCheck(this, PasswordGenerator);

    var _this = _possibleConstructorReturn(this, (PasswordGenerator.__proto__ || Object.getPrototypeOf(PasswordGenerator)).call(this, props));

    _this.state = {
      isPasswordVisible: false,
      password: {
        score: 0,
        value: '',
        isCommon: false,
        isAutoGenerated: false
      }
    };
    _this.inputRef = null;

    _this.onChangeHandler = _this.onChangeHandler.bind(_this);
    _this.generatePassword = _this.generatePassword.bind(_this);
    _this.renderPasswordStrengthMeter = _this.renderPasswordStrengthMeter.bind(_this);
    _this.setPasswordVisible = _this.setPasswordVisible.bind(_this);
    _this.unsetPasswordVisible = _this.unsetPasswordVisible.bind(_this);
    return _this;
  }

  _createClass(PasswordGenerator, [{
    key: 'onChangeHandler',
    value: function onChangeHandler(event) {
      var _props = this.props,
          generate = _props.generate,
          onChange = _props.onChange;


      if (generate) {
        this.processPasswordChange(event.target.value);
      } else {
        this.setState({
          password: _extends({}, this.state.password, {
            value: event.target.value
          })
        });
      }

      // Propagate onChange event to the Input component
      if (onChange) {
        onChange(event.target.value);
      }
    }
  }, {
    key: 'getModifyRuleObject',
    value: function getModifyRuleObject(rule) {
      var modifiedRule = _extends({}, rule);
      var isValid = rule.regex.test(this.state.password.value);

      if (isValid) {
        modifiedRule.icon = 'success';
      } else {
        modifiedRule.icon = modifiedRule.required ? 'error' : 'warning';
      }

      return modifiedRule;
    }

    // TODO refactor to smaller functions with easier ability to add negative/positive rule

  }, {
    key: 'getPasswordScore',
    value: function getPasswordScore(password) {
      var score = void 0;

      if (this.state.password.isCommon) {
        return PASSWORD_SCORE_GOOD;
      }
      var validatedRules = this.props.rules.map(function (rule) {
        return _extends({}, rule, {
          isValid: rule.regex.test(password)
        });
      });

      // Each character will give 1 point
      score = password.length;

      // Each unique character will give 5 bonus points
      var uniqueCharacters = password.split('').filter(function (item, i, ar) {
        return ar.indexOf(item) === i;
      });

      score += uniqueCharacters.length * 5;
      // Remove 2 points for each repeat characters
      var repeatCharacters = password.match(/(.)\1+/g);
      if (repeatCharacters) {
        score += repeatCharacters.join('').length * -3;
      }

      // Set max score of invalid password need to be PASSWORD_SCORE_GOOD
      var invalidRequiredRule = validatedRules.find(function (rule) {
        if (rule.required) {
          return rule.isValid === false;
        }

        return false;
      });

      if (invalidRequiredRule) {
        return score < PASSWORD_SCORE_GOOD ? score : PASSWORD_SCORE_GOOD;
      }

      // Each passed rule will give 10 bonus points
      score += validatedRules.filter(function (rule) {
        return rule.isValid;
      }).length * 10;

      return score;
    }
  }, {
    key: 'getPasswordSemanticScore',
    value: function getPasswordSemanticScore() {
      var score = this.state.password.score;

      if (score > PASSWORD_SCORE_STRONG) {
        return 'strong';
      }
      if (score > PASSWORD_SCORE_GOOD) {
        return 'good';
      }

      return 'weak';
    }
  }, {
    key: 'setPasswordVisible',
    value: function setPasswordVisible(event) {
      event.preventDefault();
      this.setState({ isPasswordVisible: true });
    }
  }, {
    key: 'unsetPasswordVisible',
    value: function unsetPasswordVisible(event) {
      event.preventDefault();
      this.setState({ isPasswordVisible: false });
    }
  }, {
    key: 'processPasswordChange',
    value: function processPasswordChange(password, isAutoGenerated) {
      var commonRegexes = this.props.common.regexes || [];

      var isCommonPassword = commonRegexes.map(function (regex) {
        return regex.test(password);
      }).includes(true);

      this.setState({
        password: {
          score: this.getPasswordScore(password),
          value: password,
          isCommon: isCommonPassword,
          isAutoGenerated: !!isAutoGenerated
        }
      });

      if (!this.state.password.isAutoGenerated) {
        this.inputRef.focus();
      }
    }
  }, {
    key: 'generatePassword',
    value: function generatePassword(event, executionsCount) {
      var length = 12;
      var string = 'abcdefghijklmnopqrstuvwxyz';
      var numeric = '0123456789';
      var punctuation = '!@#$%^&*()_+~`|}{[]:;?><,./-=';
      var password = '';
      var character = '';

      while (password.length < length) {
        var entity1 = Math.ceil(string.length * Math.random() * Math.random());
        var entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
        var entity3 = Math.ceil(punctuation.length * Math.random() * Math.random());
        var hold = string.charAt(entity1);
        hold = entity1 % 2 === 0 ? hold.toUpperCase() : hold;
        character += hold;
        character += numeric.charAt(entity2);
        character += punctuation.charAt(entity3);
        password = character;
      }

      if (this.getPasswordScore(password) < PASSWORD_SCORE_STRONG && executionsCount > 20) {
        return this.generatePassword(event, executionsCount + 1);
      }

      if (this.props.onChange) {
        this.props.onChange(password);
      }

      return this.processPasswordChange(password, true);
    }
  }, {
    key: 'renderHint',
    value: function renderHint(_ref) {
      var icon = _ref.icon,
          description = _ref.description;

      return _react2.default.createElement(
        'div',
        { className: 'password-generator__hint', key: description },
        _react2.default.createElement(_icon2.default, {
          name: ICON[icon],
          size: '14',
          className: 'password-generator__hint-icon password-generator__hint-icon--' + icon
        }),
        description
      );
    }
  }, {
    key: 'renderHints',
    value: function renderHints() {
      var _this2 = this;

      if (this.state.password.isCommon) {
        return this.renderHint({ icon: 'error', description: this.props.common.description });
      }

      return this.props.rules.map(function (rule) {
        return _this2.getModifyRuleObject(rule);
      }).map(function (rule) {
        return _this2.renderHint({ icon: rule.icon, description: rule.description });
      });
    }
  }, {
    key: 'renderPasswordStrengthMeter',
    value: function renderPasswordStrengthMeter() {
      var translation = this.props.translation;


      return _react2.default.createElement(
        'div',
        { className: 'password-generator__hints password-generator__hints--' + this.getPasswordSemanticScore() },
        _react2.default.createElement(
          _title2.default,
          { level: '6', density: 'cozy' },
          translation.recommendationTitle
        ),
        _react2.default.createElement(
          'div',
          { className: 'password-generator__strength-meter-wrapper' },
          _react2.default.createElement('div', {
            className: 'password-generator__strength-meter',
            style: { width: this.state.password.score + '%' }
          })
        ),
        this.renderHints()
      );
    }
  }, {
    key: 'renderSuffix',
    value: function renderSuffix() {
      var _this3 = this;

      var _props2 = this.props,
          generate = _props2.generate,
          translation = _props2.translation;


      return _react2.default.createElement(
        'div',
        { className: 'password-generator__suffix' },
        _react2.default.createElement(_iconButton2.default, {
          icon: this.state.isPasswordVisible ? 'eye-cross' : 'eye',
          className: 'password-generator__icon-eye',
          size: 'small',
          onTouchStart: this.setPasswordVisible,
          onTouchEnd: this.unsetPasswordVisible,
          onMouseDown: this.setPasswordVisible,
          onMouseUp: this.unsetPasswordVisible,
          onMouseLeave: this.unsetPasswordVisible
        }),
        generate && _react2.default.createElement(
          _button2.default,
          {
            action: 'button',
            color: 'dark',
            size: 'small',
            'data-e2e': 'password-generate',
            onClick: this.generatePassword
          },
          this.state.password.isAutoGenerated ? _react2.default.createElement(_icon2.default, { name: 'refresh', size: '12' }) : translation.generateButton
        ),
        this.state.password.isAutoGenerated && generate && _react2.default.createElement(
          _button2.default,
          {
            color: 'dark',
            size: 'small',
            action: 'button',
            onClick: function onClick() {
              return (0, _utils.copyToClipboard)(_this3.state.password.value);
            }
          },
          translation.copyButton
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props3 = this.props,
          className = _props3.className,
          generate = _props3.generate,
          props = _objectWithoutProperties(_props3, ['className', 'generate']);

      var common = props.common,
          translation = props.translation,
          rules = props.rules,
          type = props.type,
          value = props.value,
          dispatch = props.dispatch,
          onChange = props.onChange,
          propsToPropagate = _objectWithoutProperties(props, ['common', 'translation', 'rules', 'type', 'value', 'dispatch', 'onChange']);

      var classes = (0, _classnames2.default)('password-generator', generate && 'password-generator--custom-validation', className);

      return _react2.default.createElement(_input2.default, _extends({
        type: this.state.isPasswordVisible ? 'text' : 'password',
        value: this.state.password.value,
        validationMessageTemplate: generate ? this.renderPasswordStrengthMeter : null,
        className: classes,
        suffix: this.renderSuffix(),
        onChange: this.onChangeHandler,
        onRefsReady: function onRefsReady(input) {
          _this4.inputRef = input;
        }
      }, propsToPropagate));
    }
  }]);

  return PasswordGenerator;
}(_react2.default.Component);

PasswordGenerator.propTypes = {
  className: _propTypes2.default.string,
  rules: _propTypes2.default.array,
  common: _propTypes2.default.object,
  translation: _propTypes2.default.object,
  generate: _propTypes2.default.bool,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func
};

PasswordGenerator.defaultProps = {
  rules: [],
  common: {},
  generate: true,
  translation: {
    copyButton: 'copy',
    generateButton: 'generate',
    recommendationTitle: 'strength recommendations'
  }
};

exports.default = PasswordGenerator;